import { Yup as yup } from '@ltvco/refresh-lib/vendors';

export const schemaEmailSearchForm = yup.object({
  email: yup
    .string()
    .required('Please enter a valid email to complete search.')
    .emailStrict('Please enter a valid email to complete search.')
    .trim(),
});
